export const formatFileSize = (sizeInMB) => {
  if (sizeInMB < 1) {
    return `${Math.round(sizeInMB * 1024)} KB`;
  }
  return `~${Math.round(sizeInMB)} MB`;
};
